import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import copy from 'clipboard-copy';
import beautify from "json-beautify";

const FloatingDiv = styled.div `
  position: fixed;
  left: 0;
  bottom:0;
  background:grey;
  color: black;
  z-index:1000;
  opacity:0.5;
  a:hover {
    background-color: yellow;
  }
`;

const DraftModeCode = () => {
  const landingPageData = useSelector(state => state.config.lpdata) || {};

  const onCopy = (content) => e => {

    console.log(content);
    copy(content);
  };

  return (
    <Fragment>
 <FloatingDiv>
  <button onClick={onCopy(beautify(landingPageData.banners, null, 4, 80))}>
    COPY
 </button></FloatingDiv>
    </Fragment>
  );
};

export default DraftModeCode;
